module.exports = __webpack_public_path__ + "img/ico_biaoqianyingxiongbaowu.67c23b94.png";